import type { ScoreResult } from "./types.js";

/** Never render a shared dimension as an independent call, or a reused receipt
 * as a freshly executed reviewer. Historical scores have no invented metadata. */
export function reviewReceiptLabel(score: ScoreResult): string {
  const r = score.review;
  if (!r || r.version !== "review-2026-09-20-v1" || typeof r.requestId !== "string"
    || typeof r.reviewedDraftHash !== "string" || typeof r.appliesToDraftHash !== "string") return "该维度未记录模型调用来源";
  const source = r.reviewerId === "literary-scorer" ? "综合文学编辑 · 三维同次调用" : "独立评审";
  return r.mode === "reused"
    ? `${source} · 沿用旧稿凭证，未重新调用 · ${r.reviewedDraftHash.slice(0, 8)} → ${r.appliesToDraftHash.slice(0, 8)} · 仅行尾空白变化`
    : `${source} · ${r.scope === "targeted" ? "定向复核" : "全文评审"} · ${r.model} · 调用 ${r.requestId.slice(0, 8)}`;
}
